module.exports = __webpack_public_path__ + "static/4-77098e1d1b1a61b4a72a622a42b90a15.jpeg";